import React, { useCallback, useMemo } from "react";
import { getTranslations } from "../helpers/translations";

import Page from "../components/Page";
import DynamicContainer, {
  DynamicContainerProps,
} from "../components/DynamicContainer";
import { mapSections } from "../helpers/dynamic";
import { useIntl } from "../hooks/useIntl";
import SEO from "../components/SEO";
import { parseSEO } from "../helpers/seo";

const Dynamic = ({ pageContext }: { pageContext: any }): JSX.Element => {
  const data = pageContext?.data;
  const intl = useIntl();
  const pageUrl =
    data?.directus?.dynamic_page_by_id?.page_slug;

  const translatedData = useMemo(() => {
    return (
      getTranslations(
        data,
        "translations",
        intl.locale,
      ) ?? {}
    );
  }, [data, intl]);

  const getSections =
    useCallback((): DynamicContainerProps => {
      return {
        sections: mapSections(
          translatedData?.sections_list,
        ),
      };
    }, [translatedData]);

  const {
    initial_header_background_color,
    initial_header_text_color,
    scrolled_header_background_color,
    scrolled_header_text_color,
    hide_initial_popup,
  } = translatedData;

  return (
    <Page
      hideInitialPopup={hide_initial_popup}
      initialHeaderBackgroundColor={
        initial_header_background_color
      }
      initialHeaderFontColor={initial_header_text_color}
      scrolledHeaderBackgroundColor={
        scrolled_header_background_color
      }
      scrolledHeaderFontColor={scrolled_header_text_color}
      helmet={
        <SEO
          {...parseSEO(translatedData, intl?.locale)}
          withChatBot={
            (intl.locale === "en-US" &&
              pageUrl === "faqs") ||
            pageUrl === "mission"
              ? true
              : false
          }
        />
      }
    >
      <DynamicContainer {...getSections()} />
    </Page>
  );
};

export default Dynamic;
